import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { SocketIoConfig } from './socket-io.config';
import { SOCKET_CONFIG_TOKEN } from './socket-io.injectionToken';
import { Socket } from './socket-io.service';
import { SocketFactory } from './socket-io.factory';

@NgModule({})
export class SocketIoModule {
  static register<T extends Socket>(
    socketClass: new (...args: any[]) => T,
    config: SocketIoConfig
  ): ModuleWithProviders<SocketIoModule> {
    const token = new InjectionToken<SocketIoConfig>(`__SOCKET_CONFIG_${socketClass.name}__`);
    return {
      ngModule: SocketIoModule,
      providers: [
        { provide: token, useValue: config },
        {
          provide: socketClass,
          useFactory: (cfg: SocketIoConfig) => new socketClass(cfg),
          deps: [token],
        },
      ],
    };
  }
}
